// Translations
import accessKeyManager from 'components/model/access-key-manager/translations/tr'
import copyButton from 'components/interface/copy-button/translations/tr'
import feedback from 'components/utility/feedback/translations/tr'
import loadingError from 'components/utility/loading-error/translations/tr'
import pagination from 'components/interface/pagination/translations/tr'
import phoneNumberVerifier from 'components/model/phone-number-verifier/translations/tr'
import providerButton from 'components/external/provider-button/translations/tr'

// Translation: Turkish > Components
const components = Object.freeze({
	external: { providerButton },
	interface: { copyButton, pagination },
	model: { accessKeyManager, phoneNumberVerifier },
	utility: { feedback, loadingError }
})

// Export
export default components
